import type { ChangeEventHandler, ComponentPropsWithoutRef } from 'react';
import translations from '../../translations';
import Toggle from '../inputs/Toggle';
import type { UpdateTenant } from './TenantPage';

type ReportingProps = {
    disableServiceInvokerLogging: boolean | null | undefined;
    endpoint: string | null | undefined;
    updateTenant: UpdateTenant;
};

const Reporting = ({ disableServiceInvokerLogging, endpoint, updateTenant }: ReportingProps) => {
    const handleReportingEndpointChange: ChangeEventHandler<HTMLInputElement> = ({
        target: { value },
    }) => {
        updateTenant({
            stateSettings: {
                endpoint: value,
            },
        });
    };

    const handleServiceInvokerChange: ComponentPropsWithoutRef<typeof Toggle>['onChange'] = ({
        isOn,
    }) => {
        updateTenant({
            tenantSettings: {
                disableServiceInvokerLogging: isOn,
            },
        });
    };

    return (
        <>
            <div className="form-group">
                <label htmlFor="reporting-endpoint">
                    {translations.TENANT_reporting_endpoint_url_input_label}
                </label>
                <input
                    id="reporting-endpoint"
                    className="form-control reporting-endpoint"
                    maxLength={500}
                    value={endpoint ?? ''}
                    onChange={handleReportingEndpointChange}
                />
            </div>
            <div className="form-group">
                <label htmlFor="reporting-enable-logging-toggle">
                    <Toggle
                        id="reporting-enable-logging-toggle"
                        className="reporting-enable-logging"
                        isOn={
                            typeof disableServiceInvokerLogging === 'boolean'
                                ? disableServiceInvokerLogging
                                : true
                        }
                        onChange={handleServiceInvokerChange}
                    />
                    {translations.TENANT_reporting_enable_connector_logging_toggle_label}
                </label>
            </div>
        </>
    );
};

export default Reporting;
